import { Upload } from "antd";
// import ImgCrop from "antd-img-crop";
import { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { addWebSiteImage } from "../../Redux/Actions/CardAction";
// import { CardContext } from "../../store/CardContext";

const App = () => {
  // const dispatch = useDispatch();
  // const { websiteImage } = useSelector((state) => state.cardReducer);
  // const [fileList, setFileList] = useState(
  //   websiteImage[0]?.thumbUrl
  //     ? [
  //         {
  //           uid: "-1",
  //           name: "image.png",
  //           status: websiteImage[0]?.thumbUrl ? "done" : "",
  //           url: websiteImage[0]?.thumbUrl,
  //         },
  //       ]
  //     : []
  // );

  const [fileList, setFileList] = useState([])
  // const [userData, setUserData] = useContext(CardContext)
  const [userData, setUserData] = useState('')
  

  useEffect(() => {
    // console.log(userData,'^^^^^^^^^^^^^^^^^^^^^^');
    setFileList(
      userData.websiteImage
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.websiteImage ? "done" : "",
            url:  userData.websiteImage,
          },
        ]
      : []
    )
  }, [userData])



  const onChange = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList(newFileList);

    dispatch(addWebSiteImage(fileList));
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  return (
    <>
      {/* <ImgCrop rotationSlider> */}
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
        >
          {fileList.length < 1 && "+ Upload"}
        </Upload>
      {/* </ImgCrop> */}
    </>
  );
};
export default App;
